import { User } from '@data/models/user.interface';
import { RootState } from '@stores/models/store';

export const getUser = (state: RootState): User => {
  return state.user;
};
